import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/use-theme";
import { useHapticFeedback } from "@/hooks/use-haptic";
import { Trans, useTranslation } from "react-i18next";
import { translate } from "@/lib/translation-utils";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const { triggerHaptic } = useHapticFeedback();

  const handleThemeToggle = async () => {
    const themes: Array<"dark" | "light" | "autumn" | "winter" | "minimal"> = ["dark", "light", "autumn", "winter", "minimal"];
    const currentIndex = themes.indexOf(theme);
    const nextTheme = themes[(currentIndex + 1) % themes.length];
    setTheme(nextTheme);

    try {
      await triggerHaptic('selection');
    } catch (error) {
      console.warn('[ThemeToggle] Haptic feedback failed:', error);
    }
  };

  const themeIcons = {
    light: "🌞",
    dark: "😎",
    autumn: "🍁",
    winter: "💧",
    minimal: "🎹"
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={handleThemeToggle}
      aria-label="Toggle theme"
      className={`relative w-10 h-10 overflow-hidden
        bg-primary/10 hover:bg-primary/20 
        border border-primary/20 hover:border-primary/30 
        shadow-sm hover:shadow-md`}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-lg">
          {themeIcons[theme]}
        </span>
      </div>
      <span className="sr-only"><Trans>Toggle theme</Trans></span>
    </Button>
  );
}